import React, { useContext, useState, useEffect } from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import GlobalData from "./GlobalData";
import { DropDownListComponent } from "@syncfusion/ej2-react-dropdowns";
import {
  FormLabel,
  FormControlLabel,
  Table,
  TableBody,
  TableRow,
  TableCell,
} from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import Tools from "./JNSTools";
import { CredsContext } from "./Contexts";
import { STORAGE_OPTIONS } from "./GlobalSettingsList";
import { grey } from "@mui/material/colors";
import "./styles/Settings.css";

function SettingsInstance(props) {
  const creds = useContext(CredsContext).creds;
  let loadedSettings = JSON.parse(localStorage.getItem("oadaSettings"));
  const [showWhiteboard, setShowWhiteboard] = useState(
    loadedSettings.showWhiteboardSetting ? true : false,
  );
  const [pageContents, setPageContents] = useState(null);
  const defaultStorageOption = localStorage.getItem(
    creds.company + "|StorageOption",
  );

  /*const [oabicEnabled, setOabicEnabled] = useState(
    loadedSettings ? loadedSettings.oabicEnabled : false,
  );*/
  const handleShowWhiteboardClick = () => {
    const newShowWhiteboard = !showWhiteboard;
    props.handleSettingsChange({ showWhiteboardSetting: newShowWhiteboard });
    setShowWhiteboard(newShowWhiteboard);
  };

  const handleValueChange = (event) => {
    // parentElement.id is of the form <id>_options
    //const currentSettings = JSON.parse(localStorage.getItem("oadaSettings"));
    const keyName = event.e.target.parentElement.id;
    //loadedSettings = { ...loadedSettings, [keyName]: event.item.id };
    props.handleSettingsChange({ [keyName]: event.item.id });
    //console.log("loadedSettings: " + JSON.stringify(loadedSettings));
  };

  const handleStorageValueChange = (event) => {
    localStorage.setItem(
      creds.company + "|StorageOption",
      event.itemData.value,
    );

    const urlString = Tools.getInstanceUrl(creds);
    const authString = Tools.getXmlBodyAuthString(creds);
    const requestString =
      authString +
      '<Read type="Preference" method="equal to" limit="1"><Preference><group_name>oadaSettings</group_name><name>storageOption</name></Preference></Read></request>';
    Tools.fetchPost(requestString, urlString, "Preference").then(
      (prefRecRaw) => {
        if (prefRecRaw.xml.length > 0) {
          const prefRecArray = Tools.xmlToArray(prefRecRaw.xml);
          const modifyString =
            authString +
            '<Modify type="Preference"><Preference><id>' +
            prefRecArray[0].id +
            "</id><setting>" +
            event.itemData.value +
            "</setting></Preference></Modify></request>";
          Tools.fetchPost(modifyString, urlString);
        } else {
          const addString =
            authString +
            '<Add type="Preference"><Preference><group_name>oadaSettings</group_name><name>storageOption</name><setting>' +
            event.itemData.value +
            "</setting></Preference></Add></request>";
          Tools.fetchPost(addString, urlString);
        }
      },
    );
  };

  useEffect(() => {
    const globalData = new GlobalData(creds);
    globalData.populateTable("IssueStage").then(() => {
      globalData.populateTable("IssueCategory").then(() => {
        globalData.populateTable("IssueSeverity").then(() => {
          const issueStages = JSON.parse(
            localStorage.getItem(creds.company + "|IssueStage"),
          );
          const issueCategories = JSON.parse(
            localStorage.getItem(creds.company + "|IssueCategory"),
          );
          const issueSeverities = JSON.parse(
            localStorage.getItem(creds.company + "|IssueSeverity"),
          );
          //arrays of id,name

          const fieldDef = { text: "name", value: "id" };
          const riskSetting = issueCategories.find(
            (elem) => elem.id == loadedSettings["riskCategoryDropdown_options"],
          );
          const actionSetting = issueCategories.find(
            (elem) =>
              elem.id == loadedSettings["actionCategoryDropdown_options"],
          );
          const assumptionSetting = issueCategories.find(
            (elem) =>
              elem.id == loadedSettings["assumptionCategoryDropdown_options"],
          );
          const issueSetting = issueCategories.find(
            (elem) =>
              elem.id == loadedSettings["issueCategoryDropdown_options"],
          );
          const decisionSetting = issueCategories.find(
            (elem) =>
              elem.id == loadedSettings["decisionCategoryDropdown_options"],
          );
          const requirementSetting = issueCategories.find(
            (elem) =>
              elem.id == loadedSettings["requirementCategoryDropdown_options"],
          );
          const requirementVersionSetting = issueCategories.find(
            (elem) =>
              elem.id ==
              loadedSettings["requirementVersionsCategoryDropdown_options"],
          );
          const proposedStageSetting = issueStages.find(
            (elem) =>
              elem.id ==
              loadedSettings["proposedRequirementStageDropdown_options"],
          );
          const approvedStageSetting = issueStages.find(
            (elem) =>
              elem.id ==
              loadedSettings["approvedRequirementStageDropdown_options"],
          );
          const decisionNeededStageSetting = issueStages.find(
            (elem) =>
              elem.id == loadedSettings["decisionNeededStageDropdown_options"],
          );
          const decisionMadeStageSetting = issueStages.find(
            (elem) =>
              elem.id == loadedSettings["decisionMadeStageDropdown_options"],
          );
          const openStageSetting = issueStages.find(
            (elem) => elem.id == loadedSettings["openStageDropdown_options"],
          );
          const assignedStageSetting = issueStages.find(
            (elem) =>
              elem.id == loadedSettings["assignedStageDropdown_options"],
          );
          const pendingStageSetting = issueStages.find(
            (elem) => elem.id == loadedSettings["pendingStageDropdown_options"],
          );
          const resolvedStageSetting = issueStages.find(
            (elem) =>
              elem.id == loadedSettings["resolvedStageDropdown_options"],
          );
          const highSeveritySetting = issueSeverities.find(
            (elem) => elem.name == "High",
          );
          const mediumSeveritySetting = issueSeverities.find(
            (elem) => elem.name == "Medium",
          );
          const lowSeveritySetting = issueSeverities.find(
            (elem) => elem.name == "Low",
          );

          const contents = (
            <Box>
              <Box>
                <FormLabel>
                  <div className="settingsInstanceTitle">
                    Instance: {creds.company}
                  </div>
                  <div className="settingsGroupTitle">Record Identifiers</div>
                </FormLabel>
                <br></br>
              </Box>
              <Box display="flex">
                <Table>
                  <TableBody>
                    <TableRow>
                      <TableCell
                        sx={{
                          paddingTop: "0px",
                          border: "none",
                          textAlign: "right",
                        }}
                      >
                        <span className="settingReqCategoryLabel">
                          Category for Risks:
                        </span>
                      </TableCell>
                      <TableCell sx={{ paddingTop: "0px", border: "none" }}>
                        <DropDownListComponent
                          sortOrder="Ascending"
                          required
                          id="riskCategoryDropdown"
                          defaultValue={riskSetting ? riskSetting.name : "Risk"}
                          dataSource={issueCategories}
                          fields={fieldDef}
                          select={handleValueChange}
                          width="200px"
                          cssClass="settingReqCategoryDropdown"
                          //floatLabelType="Always"
                        />
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        sx={{
                          paddingTop: "0px",
                          border: "none",
                          textAlign: "right",
                        }}
                      >
                        <span className="settingReqCategoryLabel">
                          Category for Actions:
                        </span>
                      </TableCell>
                      <TableCell sx={{ paddingTop: "0px", border: "none" }}>
                        <DropDownListComponent
                          sortOrder="Ascending"
                          required
                          id="actionCategoryDropdown"
                          defaultValue={
                            actionSetting ? actionSetting.name : "Action"
                          }
                          dataSource={issueCategories}
                          fields={fieldDef}
                          select={handleValueChange}
                          width="200px"
                          cssClass="settingReqCategoryDropdown"
                          //floatLabelType="Always"
                        />
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        sx={{
                          paddingTop: "0px",
                          border: "none",
                          textAlign: "right",
                        }}
                      >
                        <span className="settingReqCategoryLabel">
                          Category for Assumptions:
                        </span>
                      </TableCell>
                      <TableCell sx={{ paddingTop: "0px", border: "none" }}>
                        <DropDownListComponent
                          sortOrder="Ascending"
                          required
                          id="assumptionCategoryDropdown"
                          defaultValue={
                            assumptionSetting
                              ? assumptionSetting.name
                              : "Assumption"
                          }
                          dataSource={issueCategories}
                          fields={fieldDef}
                          select={handleValueChange}
                          width="200px"
                          cssClass="settingReqCategoryDropdown"
                          //floatLabelType="Always"
                        />
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        sx={{
                          paddingTop: "0px",
                          border: "none",
                          textAlign: "right",
                        }}
                      >
                        <span className="settingReqCategoryLabel">
                          Category for Issues:
                        </span>
                      </TableCell>
                      <TableCell sx={{ paddingTop: "0px", border: "none" }}>
                        <DropDownListComponent
                          sortOrder="Ascending"
                          required
                          id="issueCategoryDropdown"
                          defaultValue={
                            issueSetting ? issueSetting.name : "Issue"
                          }
                          dataSource={issueCategories}
                          fields={fieldDef}
                          select={handleValueChange}
                          width="200px"
                          cssClass="settingReqCategoryDropdown"
                          //floatLabelType="Always"
                        />
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        sx={{
                          paddingTop: "0px",
                          border: "none",
                          textAlign: "right",
                        }}
                      >
                        <span className="settingReqCategoryLabel">
                          Category for Decisions:
                        </span>
                      </TableCell>
                      <TableCell sx={{ paddingTop: "0px", border: "none" }}>
                        <DropDownListComponent
                          sortOrder="Ascending"
                          required
                          id="decisionCategoryDropdown"
                          defaultValue={
                            decisionSetting ? decisionSetting.name : "Decision"
                          }
                          dataSource={issueCategories}
                          fields={fieldDef}
                          select={handleValueChange}
                          width="200px"
                          cssClass="settingReqCategoryDropdown"
                          //floatLabelType="Always"
                        />
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        sx={{
                          paddingTop: "0px",
                          border: "none",
                          textAlign: "right",
                        }}
                      >
                        <span className="settingReqCategoryLabel">
                          Category for Requirements:
                        </span>
                      </TableCell>
                      <TableCell sx={{ paddingTop: "0px", border: "none" }}>
                        <DropDownListComponent
                          sortOrder="Ascending"
                          required
                          id="requirementCategoryDropdown"
                          defaultValue={
                            requirementSetting
                              ? requirementSetting.name
                              : "Requirement"
                          }
                          dataSource={issueCategories}
                          fields={fieldDef}
                          select={handleValueChange}
                          width="200px"
                          cssClass="settingReqCategoryDropdown"
                          //floatLabelType="Always"
                        />
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        sx={{
                          paddingTop: "0px",
                          border: "none",
                          textAlign: "right",
                        }}
                      >
                        <span className="settingReqCategoryLabel">
                          Category for Requirement Versions:
                        </span>
                      </TableCell>
                      <TableCell sx={{ paddingTop: "0px", border: "none" }}>
                        <DropDownListComponent
                          sortOrder="Ascending"
                          required
                          id="requirementVersionsCategoryDropdown"
                          defaultValue={
                            requirementVersionSetting
                              ? requirementVersionSetting.name
                              : "Requirement Version"
                          }
                          dataSource={issueCategories}
                          fields={fieldDef}
                          select={handleValueChange}
                          width="200px"
                          cssClass="settingReqCategoryDropdown"
                          //floatLabelType="Always"
                        />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
                <Table sx={{ marginLeft: "20px" }}>
                  <TableBody>
                    <TableRow>
                      <TableCell
                        sx={{
                          paddingTop: "0px",
                          border: "none",
                          textAlign: "right",
                        }}
                      >
                        <span className="settingReqStageLabel">
                          Stage for Proposed Requirements:
                        </span>
                      </TableCell>
                      <TableCell sx={{ paddingTop: "0px", border: "none" }}>
                        <DropDownListComponent
                          sortOrder="Ascending"
                          required
                          id="proposedRequirementStageDropdown"
                          defaultValue={
                            proposedStageSetting
                              ? proposedStageSetting.name
                              : "Proposed"
                          }
                          dataSource={issueStages}
                          fields={fieldDef}
                          select={handleValueChange}
                          width="200px"
                          cssClass="settingReqStageDropdown"
                          //floatLabelType="Always"
                        />
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        sx={{
                          paddingTop: "0px",
                          border: "none",
                          textAlign: "right",
                        }}
                      >
                        <span className="settingReqStageLabel">
                          Stage for Approved Requirements:
                        </span>
                      </TableCell>
                      <TableCell sx={{ paddingTop: "0px", border: "none" }}>
                        <DropDownListComponent
                          sortOrder="Ascending"
                          required
                          id="approvedRequirementStageDropdown"
                          defaultValue={
                            approvedStageSetting
                              ? approvedStageSetting.name
                              : "Approved"
                          }
                          dataSource={issueStages}
                          fields={fieldDef}
                          select={handleValueChange}
                          width="200px"
                          cssClass="settingReqStageDropdown"
                          //floatLabelType="Always"
                        />
                      </TableCell>
                    </TableRow>

                    <TableRow>
                      <TableCell
                        sx={{
                          paddingTop: "0px",
                          border: "none",
                          textAlign: "right",
                        }}
                      >
                        <span className="settingReqStageLabel">
                          Stage for Decisions Needed:
                        </span>
                      </TableCell>
                      <TableCell sx={{ paddingTop: "0px", border: "none" }}>
                        <DropDownListComponent
                          sortOrder="Ascending"
                          required
                          id="decisionNeededStageDropdown"
                          defaultValue={
                            decisionNeededStageSetting
                              ? decisionNeededStageSetting.name
                              : "Decision Needed"
                          }
                          dataSource={issueStages}
                          fields={fieldDef}
                          select={handleValueChange}
                          width="200px"
                          cssClass="settingReqStageDropdown"
                          //floatLabelType="Always"
                        />
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        sx={{
                          paddingTop: "0px",
                          border: "none",
                          textAlign: "right",
                        }}
                      >
                        <span className="settingReqStageLabel">
                          Stage for Decisions Made:
                        </span>
                      </TableCell>
                      <TableCell sx={{ paddingTop: "0px", border: "none" }}>
                        <DropDownListComponent
                          sortOrder="Ascending"
                          required
                          id="decisionMadeStageDropdown"
                          defaultValue={
                            decisionMadeStageSetting
                              ? decisionMadeStageSetting.name
                              : "Decision Made"
                          }
                          dataSource={issueStages}
                          fields={fieldDef}
                          select={handleValueChange}
                          width="200px"
                          cssClass="settingReqStageDropdown"
                          //floatLabelType="Always"
                        />
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        sx={{
                          paddingTop: "0px",
                          border: "none",
                          textAlign: "right",
                        }}
                      >
                        <span className="settingReqStageLabel">
                          Stage for Open Issues/Risks:
                        </span>
                      </TableCell>
                      <TableCell sx={{ paddingTop: "0px", border: "none" }}>
                        <DropDownListComponent
                          sortOrder="Ascending"
                          required
                          id="openStageDropdown"
                          defaultValue={
                            openStageSetting ? openStageSetting.name : "Open"
                          }
                          dataSource={issueStages}
                          fields={fieldDef}
                          select={handleValueChange}
                          width="200px"
                          cssClass="settingReqStageDropdown"
                          //floatLabelType="Always"
                        />
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        sx={{
                          paddingTop: "0px",
                          border: "none",
                          textAlign: "right",
                        }}
                      >
                        <span className="settingReqStageLabel">
                          Stage for Assigned Issues/Risks:
                        </span>
                      </TableCell>
                      <TableCell sx={{ paddingTop: "0px", border: "none" }}>
                        <DropDownListComponent
                          sortOrder="Ascending"
                          required
                          id="assignedStageDropdown"
                          defaultValue={
                            assignedStageSetting
                              ? assignedStageSetting.name
                              : "Assigned"
                          }
                          dataSource={issueStages}
                          fields={fieldDef}
                          select={handleValueChange}
                          width="200px"
                          cssClass="settingReqStageDropdown"
                          //floatLabelType="Always"
                        />
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        sx={{
                          paddingTop: "0px",
                          border: "none",
                          textAlign: "right",
                        }}
                      >
                        <span className="settingReqStageLabel">
                          Stage for Pending Issues/Risks:
                        </span>
                      </TableCell>
                      <TableCell sx={{ paddingTop: "0px", border: "none" }}>
                        <DropDownListComponent
                          sortOrder="Ascending"
                          required
                          id="pendingStageDropdown"
                          defaultValue={
                            pendingStageSetting
                              ? pendingStageSetting.name
                              : "Pending"
                          }
                          dataSource={issueStages}
                          fields={fieldDef}
                          select={handleValueChange}
                          width="200px"
                          cssClass="settingReqStageDropdown"
                          //floatLabelType="Always"
                        />
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        sx={{
                          paddingTop: "0px",
                          border: "none",
                          textAlign: "right",
                        }}
                      >
                        <span className="settingReqStageLabel">
                          Stage for Resolved Issues/Risks:
                        </span>
                      </TableCell>
                      <TableCell sx={{ paddingTop: "0px", border: "none" }}>
                        <DropDownListComponent
                          sortOrder="Ascending"
                          required
                          id="resolvedStageDropdown"
                          defaultValue={
                            resolvedStageSetting
                              ? resolvedStageSetting.name
                              : "Resolved"
                          }
                          dataSource={issueStages}
                          fields={fieldDef}
                          select={handleValueChange}
                          width="200px"
                          cssClass="settingReqStageDropdown"
                          //floatLabelType="Always"
                        />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </Box>
              <br></br>
              <FormLabel>
                <div className="settingsGroupTitle">RAID Item Priorities</div>
                <DropDownListComponent
                  sortOrder="Ascending"
                  required
                  id="highSeverityDropdown"
                  defaultValue={
                    highSeveritySetting ? highSeveritySetting.name : "High"
                  }
                  dataSource={issueSeverities}
                  fields={fieldDef}
                  select={handleValueChange}
                  width="200px"
                  cssClass="settingSeverityDropdown"
                  //floatLabelType="Always"
                />
                <br></br>
                <DropDownListComponent
                  sortOrder="Ascending"
                  required
                  id="mediumSeverityDropdown"
                  defaultValue={
                    mediumSeveritySetting
                      ? mediumSeveritySetting.name
                      : "Medium"
                  }
                  dataSource={issueSeverities}
                  fields={fieldDef}
                  select={handleValueChange}
                  width="200px"
                  cssClass="settingSeverityDropdown"
                  //floatLabelType="Always"
                />
                <br></br>
                <DropDownListComponent
                  sortOrder="Ascending"
                  required
                  id="lowSeverityDropdown"
                  defaultValue={
                    lowSeveritySetting ? lowSeveritySetting.name : "Low"
                  }
                  dataSource={issueSeverities}
                  fields={fieldDef}
                  select={handleValueChange}
                  width="200px"
                  cssClass="settingSeverityDropdown"
                  //floatLabelType="Always"
                />
                <br></br>
              </FormLabel>
              <br></br>
              <br></br>
              <FormLabel>
                <div className="settingsGroupTitle">
                  Attachment Storage Option
                </div>
                <DropDownListComponent
                  sortOrder="Ascending"
                  required
                  id="storageDropdown"
                  defaultValue={defaultStorageOption || STORAGE_OPTIONS[0]}
                  dataSource={STORAGE_OPTIONS}
                  select={handleStorageValueChange}
                  width="200px"
                  cssClass="settingReqCategoryDropdown"
                />
              </FormLabel>
              <br></br>
              <br></br>
              <FormLabel>
                <div className="settingsGroupTitle">
                  Status Report &quot;Reply To&quot; address
                </div>
                <DropDownListComponent
                  sortOrder="Ascending"
                  required
                  id="storageDropdown"
                  defaultValue={defaultStorageOption || STORAGE_OPTIONS[0]}
                  dataSource={STORAGE_OPTIONS}
                  select={handleStorageValueChange}
                  width="200px"
                  cssClass="settingReqCategoryDropdown"
                />
              </FormLabel>
            </Box>
          );

          setPageContents(contents);
        });
      });
    });
  }, [showWhiteboard]);

  return pageContents;
}

export default SettingsInstance;

SettingsInstance.propTypes = {
  handleSettingsChange: PropTypes.func,
};

/*

            <hr></hr>
            <Box>
              <FormControl>
                <FormControlLabel
                  checked={oabicEnabled}
                  onClick={handleOabicEnabledClick}
                  control={
                    <Checkbox
                      size="small"
                      sx={{
                        color: grey[50],
                        "&.Mui-checked": {
                          color: grey[50],
                        },
                      }}
                    />
                  }
                  label="SuiteProjects Pro Business Intelligence Connector enabled"
                  className="settingsRadioButtonLabel"
                />
              </FormControl>
            </Box>
            */

/*const handleOabicEnabledClick = () => {
    const currentSettings = JSON.parse(localStorage.getItem("oadaSettings"));
    const newSettings = {
      ...currentSettings,
      oabicEnabled: !oabicEnabled,
    };
    localStorage.setItem("oadaSettings", JSON.stringify(newSettings));
    Tools.writeSettings(creds);
    setOabicEnabled(!oabicEnabled);
  };*/

/* <br></br>
  <br></br>
  <FormLabel>
    <div className="settingsGroupTitle">Data Visibility</div>
    <FormControlLabel
      checked={showWhiteboard}
      onClick={handleShowWhiteboardClick}
      control={
        <Checkbox
          size="small"
          sx={{
            marginLeft: "20px",
            color: grey[50],
            "&.Mui-checked": {
              color: grey[50],
            },
          }}
        />
      }
      label="Enable Whiteboard Module"
      className="settingsRadioButtonLabel"
    />
  </FormLabel>*/
